import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/HeaderPictures/headerImg1.png'; 
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      <Container>
        
        <Row className="py-5 align-items-start">
          
          {/* 1) Logo & Description (Left) */}
          <Col lg={4} md={12} className="text-start mb-4 mb-lg-0">
            <img src={logo} height="45" alt="Infiniti Logo" className="mb-3 footer-logo" />
            <p className="footer-about">
              At INFINITI, we bridge the gap between talent and opportunity in Central Florida.
            </p>
          </Col>

          {/* 2) Links (Middle) */}
          <Col lg={4} md={12} className="text-center mb-4 mb-lg-0">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links-row list-unstyled d-flex flex-wrap justify-content-center">
              <li><Link to="/" className={`foot-link-custom ${location.pathname === '/' ? 'active' : ''}`}>Home</Link></li>
              <li><Link to="/about-us" className={`foot-link-custom ${location.pathname === '/about-us' ? 'active' : ''}`}>About</Link></li>
              <li><Link to="/find-jobs" className={`foot-link-custom ${location.pathname === '/find-jobs' ? 'active' : ''}`}>Find Jobs</Link></li>
              <li><Link to="/locations" className={`foot-link-custom ${location.pathname === '/locations' ? 'active' : ''}`}>Locations</Link></li>
              <li><Link to="/contact-us" className={`foot-link-custom ${location.pathname === '/contact-us' ? 'active' : ''}`}>Contact</Link></li>
            </ul>
          </Col>

          {/* 3) Contact Info (Right) */}
          <Col lg={4} md={12} className="text-lg-end text-center">
            <h5 className="footer-title">Connect With Us</h5>
            <p className="contact-info mb-1">info@infinitiemployment.com</p>
            <p className="contact-info">407-894-2199</p>
          </Col>

        </Row>

        <hr className="footer-divider" />

        <Row className="py-3">
          <Col className="text-center">
            <p className="copyright-text">
              © {currentYear} INFINITI Employment Solutions. All rights reserved.
            </p>
          </Col>
        </Row>

      </Container>
    </footer>
  );
};

export default Footer;